import { z } from "zod";

export const SendEmailReservationOtaResponseSchema = z.object({
    success: z.literal(true),
    message: z.string(),
    code: z.literal(200),
    data: z.null(),
});

export type SendEmailReservationOtaResponse = z.infer<typeof SendEmailReservationOtaResponseSchema>;
